import React, { useState, useRef, useEffect } from 'react';
import { Button, Modal, Badge, Tooltip, OverlayTrigger, } from 'react-bootstrap';
import Select, { components } from "react-select";
import axios from "axios";
const SubscriptionCalculation = ({ show, onClose }) => {

const baseURL = process.env.REACT_APP_API_BASE_URL; 
 

// GST percentage from API
const [gstPercentage, setGstPercentage] = useState(0);

useEffect(() => {
    axios.get(`${baseURL}/generalSetting/1`)
        .then(response => {
            if (response.data && response.data.data) {
                setGstPercentage(parseFloat(response.data.data.gst));
            } else {
                console.log("Unexpected API response structure:", response);
                setGstPercentage(5);
            }
        })
        .catch(error => {
            console.log("Failed to fetch general settings:", error);
            setGstPercentage(5);
        });
}, []);

// Checklist items
const [checklist, setChecklist] = useState([
    { id: Date.now(), package: null, amount: 0, packageID: null }
]);

const handleAddConfig = () => {
    setChecklist(prev => [
        ...prev,
        { id: Date.now(), package: null, amount: 0, packageID: null }
    ]);
};

const handleDeleteConfig = (id) => {
    setChecklist(prev => prev.filter(item => item.id !== id));
};

// Package options
const [packageOptions, setPackageOptions] = useState([]);

useEffect(() => {
    const fetchPackages = async () => {
        try {
            const res = await fetch(`${baseURL}/dropdown/package`);
            if (!res.ok) throw new Error("Failed to fetch packages");

            const data = await res.json();

            const options = data.data.map(pkg => ({
                label: pkg.package_name,
                value: pkg.selling_amount,
                ...pkg
            }));

            setPackageOptions(options);
        } catch (err) {
            console.error("Error fetching packages:", err);
        }
    };

    fetchPackages();
}, []);

// Handle package selection
const handlePackageChange = (selectedPackage, id) => {
    setChecklist(prev =>
        prev.map(item =>
            item.id === id
                ? { 
                    ...item, 
                    package: selectedPackage, 
                    amount: Number(selectedPackage.selling_amount) || 0,
                    packageID: selectedPackage.id 
                  }
                : item
        )
    );
};

// Coupon logic
const [showInput, setShowInput] = useState(false);
const [coupon, setCoupon] = useState('');
const [couponAmount, setCouponAmount] = useState(0);
const [couponID, setCouponID] = useState(null);
const [errorMessage, setErrorMessage] = useState('');

const handleIconClick = () => setShowInput(true);

const handleApplyClick = () => {
    if (!coupon) {
        setErrorMessage('Coupon Code is Required.');
        setTimeout(() => setErrorMessage(''), 5000);
        setShowInput(false);
        return;
    }

    const filter = { coupon_code: coupon || '', coupon_for: 0 };

    axios.get(`${baseURL}/coupon/code`, { params: filter })
        .then(response => {
            if (response.data.data) {
                const datas = response.data.data;
                setCouponID(datas.sno);
                if (datas.coupon_type === 0) {
                    setCouponAmount(parseFloat(datas.coupon_value));
                } else if (datas.coupon_type === 1) {
                    const val = checklist.reduce((sum, item) => sum + (Number(item.amount) || 0), 0) 
                                * (parseFloat(datas.coupon_value) / 100);
                    setCouponAmount(val);
                }
            } else {
                setCouponAmount(0);
                setCouponID(null);
                setErrorMessage('Coupon not valid or expired');
                setTimeout(() => setErrorMessage(''), 5000);
            }
            setShowInput(false);
        })
        .catch(error => {
            console.log('Error fetching coupon:', error);
            setCouponAmount(0);
            setCouponID(null);
            setShowInput(false);
            setErrorMessage('Error fetching coupon. Please try again.');
            setTimeout(() => setErrorMessage(''), 5000);
        });
};

// Subtotal, GST, total
const [subtotalPrice, setSubtotalPrice] = useState(0);
const [gst, setGst] = useState(0);
const [totalAmount, setTotalAmount] = useState(0);

useEffect(() => {
    const subtotal = checklist.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
    setSubtotalPrice(subtotal);

    const gstValue = subtotal * (gstPercentage / 100); // <-- updated
    setGst(gstValue);

    const total = subtotal + gstValue - (couponAmount || 0); // <-- updated
    setTotalAmount(total);
}, [checklist, gstPercentage, couponAmount]); // <-- updated dependencies


// Format Indian currency
function formatIndianCurrency(amount) {
    if (amount === null || amount === '' || isNaN(amount)) return '0';
    const amtStr = parseFloat(amount).toFixed(2);
    const [numberPart, decimalPart] = amtStr.split('.');
    const lastThree = numberPart.slice(-3);
    let restUnits = numberPart.slice(0, -3);
    if (restUnits !== '') {
        const restWithCommas = restUnits.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
        return decimalPart === '00' 
            ? restWithCommas + ',' + lastThree 
            : restWithCommas + ',' + lastThree + '.' + decimalPart;
    } else {
        return decimalPart === '00' ? lastThree : lastThree + '.' + decimalPart;
    }
}

// Custom styles (for Select component, if any)
const customStyles = {
    groupHeading: (provided) => ({
        ...provided,
        fontSize: '14px',
        fontWeight: 'bold',
        color: '#333',
    }),
};
 




    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Subscription Calculation</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className='scroll-y mh-350px py-2'>
                            <div className="col-lg-12">
                                <div className="mb-0">
                                    {checklist.map(config => (
                                    <div key={config.id} data-repeater-item>
                                        <div className="row">
                                        <div className="col-lg-8 mb-4">
                                            <label className="text-black font-w500 fs-7">
                                            Package <span className="required">*</span>
                                            </label>
                                           <Select
                                                placeholder="Select Package"
                                                value={config.package} // full object
                                                onChange={(selectedOption) => handlePackageChange(selectedOption, config.id)}
                                                options={packageOptions}
                                                getOptionLabel={(option) => option.package_name}
                                                getOptionValue={(option) => option.id} // use unique id here
                                                menuPlacement="bottom"
                                                menuPosition="fixed"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    ...customStyles,
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                }}
                                            />

                                        </div>

                                        <div className="col-lg-3 mb-4">
                                            <label className="text-black font-w500 fs-7">Amount</label>
                                         <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Amount"
                                            value={config.amount || 0} // always fallback to 0
                                            readOnly
                                        />


                                        </div>

                                        <div className="col-lg-1 mb-1 px-1 py-1">
                                            {checklist.length > 1 && (
                                            <button
                                                className="btn btn-danger mt-4 px-2 py-2"
                                                onClick={() => handleDeleteConfig(config.id)}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Delete"
                                            >
                                                <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                            </button>
                                            )}
                                        </div>
                                        </div>
                                    </div>
                                    ))} 

                                </div>
                            </div>
                        </div>
                        <div className="mb-1">
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={handleAddConfig}
                            >
                                <span><i className="fa-solid fa-plus fs-6"></i></span>
                                <span className='ms-2 fs-7'>Add More</span>
                            </button>
                        </div>
                    </div>
                   <div className='row  d-flex justify-content-end'>
    <div className='col-lg-6'>
        <div className='row mb-2'>
            <div className='col-lg-12 d-flex justify-content-between'>
                <div className='text-black font-w500 fs-4'>Sub Total</div>
                <div>
                    <label className='text-black font-w500 fs-3'>
                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                        <span>{formatIndianCurrency(subtotalPrice)}</span>
                    </label>
                </div>
            </div>
             <div className='col-lg-12 d-flex justify-content-between'>
                                                <div className='text-black font-w500 fs-5 d-flex align-items-center'>
                                                    {!showInput ? (
                                                        <>
                                                            <label className='text-black font-w500 fs-5'>
                                                                <span>Discount</span>
                                                            </label>
                                                            <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Apply Coupon</span></Tooltip>} >
                                                                <span onClick={handleIconClick} className='ms-3' style={{ cursor: 'pointer' }}>
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        height="50"
                                                                        id="coupon"
                                                                        enableBackground="new 0 0 512 512"
                                                                        viewBox="0 0 512 512"
                                                                    >
                                                                        <path
                                                                            fill="#ff4646"
                                                                            d="M400,368H48c0-17.673-14.327-32-32-32V112c17.673,0,32-14.327,32-32h352c0,17.673,14.327,32,32,32v224
                                            C414.327,336,400,350.327,400,368z"
                                                                        />
                                                                        <path
                                                                            fill="#a5c3dc"
                                                                            d="M200,328H88c-8.837,0-16-7.163-16-16V200h144v112C216,320.837,208.837,328,200,328z"
                                                                        />
                                                                        <path
                                                                            fill="#e6e6eb"
                                                                            d="M120,328H72c-8.837,0-16-7.163-16-16V200h80v112C136,320.837,128.837,328,120,328z"
                                                                        />
                                                                        <rect width="40" height="16" x="56" y="200" fill="#a5c3dc" />
                                                                        <path
                                                                            fill="#a5c3dc"
                                                                            d="M48,160h176c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
                                                C40,163.582,43.582,160,48,160z"
                                                                        />
                                                                        <path
                                                                            fill="#e6e6eb"
                                                                            d="M48,160h88c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
                                                C40,163.582,43.582,160,48,160z"
                                                                        />
                                                                        <rect width="16" height="128" x="88" y="200" fill="#463c4b" />
                                                                        <rect width="16" height="16" x="88" y="200" fill="#32283c" />
                                                                        <rect width="16" height="40" x="80" y="160" fill="#463c4b" />
                                                                        <rect width="16" height="40" x="176" y="160" fill="#32283c" />
                                                                        <rect width="16" height="128" x="168" y="200" fill="#32283c" />
                                                                        <path
                                                                            fill="#32283c"
                                                                            d="M196,104c-15.033,0-29.168,5.854-39.8,16.485L136,140.686l-20.201-20.201C105.168,109.854,91.033,104,76,104
                                            c-15.439,0-28,12.561-28,28s12.561,28,28,28h120c15.439,0,28-12.561,28-28S211.439,104,196,104z M76,144c-6.617,0-12-5.383-12-12
                                            s5.383-12,12-12c10.76,0,20.877,4.19,28.485,11.799L116.687,144H76z M196,144h-40.687l12.2-12.201
                                            C175.123,124.19,185.24,120,196,120c6.617,0,12,5.383,12,12S202.617,144,196,144z"
                                                                        />
                                                                        <g>
                                                                            <rect width="16" height="32" x="256" y="112" fill="#e6e6eb" />
                                                                            <rect width="16" height="16" x="256" y="80" fill="#e6e6eb" />
                                                                            <rect width="16" height="16" x="256" y="352" fill="#e6e6eb" />
                                                                            <rect width="16" height="32" x="256" y="160" fill="#e6e6eb" />
                                                                            <rect width="16" height="32" x="256" y="208" fill="#e6e6eb" />
                                                                            <rect width="16" height="32" x="256" y="256" fill="#e6e6eb" />
                                                                            <rect width="16" height="32" x="256" y="304" fill="#e6e6eb" />
                                                                        </g>
                                                                        <g>
                                                                            <path
                                                                                fill="#e6e6eb"
                                                                                d="M320,200c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S333.233,200,320,200z M320,168
                                            c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S324.411,168,320,168z"
                                                                            />
                                                                        </g>
                                                                        <g>
                                                                            <path
                                                                                fill="#e6e6eb"
                                                                                d="M384,296c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S397.233,296,384,296z M384,264
                                            c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S388.411,264,384,264z"
                                                                            />
                                                                        </g>
                                                                        <g>
                                                                            <path
                                                                                fill="#e6e6eb"
                                                                                d="M319.994,296.002c-1.203,0-2.423-0.272-3.572-0.846c-3.951-1.976-5.553-6.781-3.577-10.733l64-128
                                            c1.977-3.952,6.78-5.552,10.733-3.578c3.951,1.976,5.553,6.781,3.577,10.733l-64,128
                                            C325.754,294.381,322.929,296.002,319.994,296.002z"
                                                                            />
                                                                        </g>
                                                                    </svg>
                                                                </span>
                                                            </OverlayTrigger>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <input
                                                                className='form-control w-125px h-30px me-2 mb-2'
                                                                placeholder='Enter Coupon'
                                                                value={coupon}
                                                                onChange={(e) => setCoupon(e.target.value)}
                                                            />
            
                                                        </>
                                                    )}
                                                </div>
            
                                                <div className='text-black font-w500 fs-4 ms-5 align-items-center d-flex'>
                                                    {!showInput ? (
                                                        <>
                                                            <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                                            <label>{formatIndianCurrency(couponAmount)}</label>
                                                        </>
                                                    ) : (
                                                        <button className='btn btn-sm btn-secondary mb-2' onClick={handleApplyClick}>
                                                            Apply
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
            
                                            {errorMessage && (
                                                <div style={{ color: 'red', marginBottom: '0.5rem'}}>
                                                    {errorMessage}
                                                </div>
                                            )}

            {/* <div className='col-lg-12 d-flex justify-content-between'>
                <div className='text-black font-w500 fs-5 d-flex align-items-center'>
                    {!showInput ? (
                        <>
                            <label className='text-black font-w500 fs-5'>
                                <span>Discount</span>
                            </label>
                            <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Apply Coupon</span></Tooltip>} >
                                <span onClick={handleIconClick} className='ms-3' style={{ cursor: 'pointer' }}>
                              
                                </span>
                            </OverlayTrigger>
                        </>
                    ) : (
                        <>
                            <input
                                className='form-control w-125px h-30px me-2 mb-2'
                                placeholder='Enter Coupon'
                                value={coupon}
                                onChange={(e) => setCoupon(e.target.value)}
                            />
                        </>
                    )}
                </div>

                <div className='text-black font-w500 fs-4 ms-5 align-items-center d-flex'>
                    {!showInput ? (
                        <>
                            <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                            <label>{formatIndianCurrency(couponAmount)}</label>  
                        </>
                    ) : (
                        <button className='btn btn-sm btn-secondary mb-2' onClick={handleApplyClick}>
                            Apply
                        </button>
                    )}
                </div>
            </div>

            {errorMessage && (
                <div style={{ color: 'red', marginBottom: '0.5rem'}}>
                    {errorMessage}
                </div>
            )} */}

            <div className='col-lg-12 d-flex justify-content-between mb-2'>
                <div className='text-black font-w500 fs-5'>
                    <label className='text-black font-w500 fs-5'>GST</label>
                    <label className='text-danger font-w600 fs-5 ms-1'>( {gstPercentage}% )</label> {/* fixed */}
                </div>
                <div className='text-black font-w500 fs-4'>
                    <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                    <label className='text-black font-w500 fs-4'>{formatIndianCurrency(gst)}</label>
                </div>
            </div>

            <div className='col-lg-12 d-flex justify-content-between mb-2'>
                <label className='text-black font-w500 fs-3'>Total Amount</label>
                <div>
                    <label className='text-danger fw-bold fs-2'>
                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                        <span>{formatIndianCurrency(totalAmount)}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>

                </div>
            </div>
        </Modal>
    );
};

export default SubscriptionCalculation;
